import React, { useEffect, useRef, useState } from 'react';
import { Form, Select } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store';
import { GET_NATIONALITIES } from '../../../../redux/actions/accountActions';
import { getIsMobile, getNationalities } from '../../../../redux/selectors';
import { getUniversityId } from '../../../../helpers/Helpers';
function optionsFetcher(dispatch) {
    return function (_a) {
        var universityId = _a.universityId;
        dispatch({
            type: GET_NATIONALITIES,
            payload: {
                universityId: universityId,
            },
        });
    };
}
var defaultOptionMapper = function (_a) {
    var name = _a.name, id = _a.id;
    return { label: name, value: id };
};
export var NationalityFormItem = function () {
    var dispatch = useAppDispatch();
    var nationality = useAppSelector(getNationalities);
    var isMobile = useAppSelector(getIsMobile);
    var universityId = getUniversityId();
    var fetchOptions = useRef(optionsFetcher(dispatch));
    var _a = useState(), options = _a[0], setOptions = _a[1];
    useEffect(function () {
        if (nationality.length > 0) {
            var parsedItems = nationality.map(function (item) { return defaultOptionMapper(item); });
            setOptions(parsedItems);
        }
    }, [nationality]);
    var onDropdownVisibleChange = function (open) {
        if (open && !options) {
            fetchOptions.current({
                universityId: universityId,
            });
        }
    };
    return (React.createElement(Form.Item, { name: "nationality", label: isMobile ? null : 'Nationality', rules: [
            {
                required: true,
                message: 'Please select a country',
            },
        ] },
        React.createElement(Select, { showSearch: true, placeholder: "Nationality", optionFilterProp: "label", onDropdownVisibleChange: onDropdownVisibleChange, options: options })));
};
